import * as React from 'react';
import SuperCritical from 'lib/supercritical';

export const ActionLoadingIndicator = SuperCritical(({ loading } : { loading : () => boolean }) =>
    loading() 
    ? <div className="actionloadingindicator pc-card">
            <div className="loading-indicator"></div><div className="loading-text">Loading ...</div>
      </div>
    : null
);

// TH 05/10/2017 -- The large loading clock used on Reservations Dashboard, Batches Dashboard, elsewhere.
export const PageLoadingIndicator = SuperCritical(({ loading } : { loading : () => boolean }) =>
    loading() ? <span className="pageloadingindicator"></span> : null
);


// WEBPACK FOOTER //
// ./apps/core/actionloadingindicator/view.tsx